import React from "react";
import { Routes,Route } from "react-router-dom";
import Navbar from "./components/Navbar/Navbar";
import "./styles/variables.scss";
import Footer from "./components/Footer/Footer";
import Platform from "./pages/Platform/Platform";
import Solutions from "./pages/Solutions/Solutions";
import ContactUs from "./pages/ContactUs/ContactUs";
import Home from "./pages/Home/Home";
import Aboutus from "./pages/AboutUs/Aboutus";
import Services from "./pages/Services/Services";
import ServicesIndividualPage from "./pages/ServicesIndividualPage/ServicesIndividualPage";
import PrivacyPolicy from "./pages/PrivacyPages/Privacy";
import SolutionsIndividualPage from "./pages/SolutionsIndividualPage/SolutionsIndividualPage";
import ScrollToTop from "./components/ScrollToTop";

const App = () => {
  return (
    <div className="app">
      <ScrollToTop/>
      <Navbar />
      <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/services" element={<Services />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/services/:slug" element={<ServicesIndividualPage />} />
      <Route path="/platforms" element={<Platform />} />
      <Route path="/aboutus" element={<Aboutus />} />
      <Route path="/solutions" element={<Solutions />} />
      <Route path="/solutions/:slug" element={<SolutionsIndividualPage />} />
      <Route path="/contact" element={<ContactUs/>}/>
      </Routes>
      <Footer/>
    </div>
  );
};

export default App;
